var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.click}},[_vm._v(" Resend Email ")])}
var staticRenderFns = []

export { render, staticRenderFns }